module.exports = __webpack_public_path__ + "img/phone.b8a34d53.png";